import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { fetchWithAuth } from '../utils/authUtils';

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

const formatDateTime = (value) => {
  if (!value) return '';
  const d = new Date(value);
  return d.toLocaleString('vi-VN', { hour12: false });
};

const resolveImg = (src) => {
  if (!src) return '';
  if (src.startsWith('http')) return src;
  if (src.startsWith('/')) return `${API_BASE}${src}`;
  return src;
};

const BlogDetail = () => {
  const { blogId } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const normalize = (r) => (!r ? null : {
    blogID: r.blogID ?? r.BlogID ?? r.id ?? r.Id,
    title: r.title ?? r.Title ?? '',
    summary: r.summary ?? r.Summary ?? '',
    content: r.content ?? r.Content ?? '',
    image: r.image ?? r.Image ?? '',
    CategoryName: r.CategoryName ?? r.categoryName ?? r.Category ?? r.category ?? '',
    authorID: r.authorID ?? r.AuthorID ?? null,
    createdAt: r.createdAt ?? r.CreatedAt ?? r.created_at ?? null,
    status: r.status ?? r.Status ?? 1,
  });

  useEffect(() => {
    let aborted = false;
    (async () => {
      try {
        setLoading(true);
        setError('');
        const res = await fetchWithAuth(`${API_BASE}/api/blogs/${blogId}`).catch(() => null);
        if (!res) { setBlog(null); return; }
        const json = await res.json().catch(() => ({}));
        const data = json?.data ?? json ?? null;
        if (!aborted) setBlog(normalize(data));
      } catch (e) {
        if (!aborted) { setBlog(null); setError(e?.message || 'Không thể tải bài viết.'); }
      } finally {
        if (!aborted) setLoading(false);
      }
    })();
    return () => { aborted = true; };
  }, [blogId]);

  const html = blog?.content ? String(blog.content)
    .replace(/\n/g, '<br>') : '';

  return (
    <div style={{ background: '#f8fafc', minHeight: '100vh' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '96px 16px 48px' }}>
        <div style={{ marginBottom: 12 }}>
          <Link to="/blogs" style={{ textDecoration: 'none', color: '#2c5282' }}>{'← Quay lại'}</Link>
        </div>

        {loading && <div className="tamcare-alert">Đang tải...</div>}
        {error && <div className="tamcare-alert tamcare-alert--error">{error}</div>}
        {!loading && !error && !blog && <div className="tamcare-alert">Không tìm thấy bài viết.</div>}

        {blog && (
          <article style={{ background: '#fff', borderRadius: 14, overflow: 'hidden', boxShadow: '0 10px 25px rgba(0,0,0,0.06)', border: '1px solid #e2e8f0' }}>
            {blog.image && (
              <img src={resolveImg(blog.image)} alt={blog.title} style={{ width: '100%', height: 320, objectFit: 'cover', display: 'block' }} />
            )}
            <div style={{ padding: 18 }}>
              {(blog.category || blog.CategoryName) && (
                <div style={{ fontSize: 12, color: '#2c5282', background: '#e0effa', display: 'inline-block', padding: '4px 8px', borderRadius: 999, fontWeight: 700, marginBottom: 8 }}>{blog.CategoryName || blog.category}</div>
              )}
              <h1 style={{ margin: '8px 0 8px', color: '#1e293b', fontWeight: 800 }}>{blog.title}</h1>
              <div style={{ color: '#94a3b8', fontSize: 12 }}>{formatDateTime(blog.createdAt)}</div>
              {blog.summary && <p style={{ marginTop: 6, color: '#334155', fontSize: 16 }}>{blog.summary}</p>}
              <div style={{ marginTop: 14, color: '#0f172a', lineHeight: 1.8 }}
                dangerouslySetInnerHTML={{ __html: html }}
              />
            </div>
          </article>
        )}
      </div>
    </div>
  );
};

export default BlogDetail;
